import {Component, OnInit, OnDestroy, ChangeDetectionStrategy} from '@angular/core';

import {UserService} from '../../services/user.service';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {LoaderService} from '../../services/loader.service';
import { Editor, Toolbar } from 'ngx-editor';
import {User} from '../../models/user';
import {MailContactService} from '../../services/mail-contact.service';
import {ToastService} from '../../services/toast.service';
import {ErrorService} from '../../services/error.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ReCaptchaV3Service} from 'ng-recaptcha-2';
import {Subscription} from 'rxjs';
import {LogementService} from "../../services/logement.service";

@Component({
    selector: 'app-nous-contacter',
    templateUrl: './nous-contacter.component.html',
    styleUrls: ['./nous-contacter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class NousContacterComponent implements OnInit{
  private subscriptionCaptcha: Subscription;
  public logementCourantSub: Subscription;

  emails: any = [{name: "Équipe Cléa", email: 'equipe.clea@qualitel.org'}];
  isReady = false;
  showConfirmation = false;
  editor: Editor;
  toolbar: Toolbar = [['align_left', 'align_center', 'align_right', 'bullet_list', 'ordered_list', 'bold', 'italic', 'link']];
  user: User;
  form: UntypedFormGroup;
  clicked = false;

  constructor(
    private userService: UserService,
    private fb: UntypedFormBuilder,
    private loaderService: LoaderService,
    private mailContactService: MailContactService,
    private toastService: ToastService,
    private errorService: ErrorService,
    public modalService: NgbModal,
    private recaptchaV3Service: ReCaptchaV3Service,
    public logementService: LogementService,
    )
  {
    this.editor = new Editor();
  }

  ngOnInit(): void {
    this.toogleGrecaptchaBadge();

    this.userService.load().then((user) => {
      this.user = user;
      this.intiForm();
    });

    this.logementCourantSub = this.logementService.logementCourant.subscribe(logement => {
      if (logement && logement?.societe?.partner?.contactClient === true && logement?.correspondantClient) {
        this.emails.push({
          name:  'Conseiller ' + logement.societe.partner.raisonSociale,
          email: logement.correspondantClient.adresseEmail
        });
      }
    });
  }

  ngOnDestroy(): void{
    this.toogleGrecaptchaBadge();

    if (this.subscriptionCaptcha) {
      this.subscriptionCaptcha.unsubscribe();
    }

    if (this.logementCourantSub) {
      this.logementCourantSub.unsubscribe();
    }
  }

  get f() { return this.form.controls; }

  private toogleGrecaptchaBadge(){
    const badge: any = document.getElementsByClassName('grecaptcha-badge');

    if (badge.length > 0){
      if (badge[0].style.visibility === 'hidden'){
        badge[0].style.visibility = 'visible';
      }else {
        badge[0].style.visibility = 'hidden';
      }
    }
  }

  intiForm(){
    this.form = new UntypedFormGroup({
      objet: new UntypedFormControl('', [
        Validators.required,
      ]),
      content: new UntypedFormControl('', [
        Validators.required,
      ]),
      destinataire: new UntypedFormControl(this.emails[this.emails.length - 1].email, [
        Validators.required,
      ])
    });
    this.isReady = true;
  }

  confirmation(){
    if (this.form.invalid) {
      return;
    }
    this.showConfirmation = true;
  }

  dismiss(){
    this.showConfirmation = false;
    this.modalService.dismissAll();
  }

  send() {
    if (this.form.invalid) {
      return;
    }
    this.subscriptionCaptcha = this.recaptchaV3Service.execute('contact')
      .subscribe((token: string) => {
            const data = Object.assign(
              this.form.getRawValue(),
              {
                nom: this.user.nom,
                prenom: this.user.prenom,
                adresseEmail: this.user.adresseEmail,
                recaptcha_response: token
              }
            );

            this.mailContactService.send(data).then((response) => {
              if (response.status == 200){
                this.toastService.showSuccess(response.message);
                this.modalService.dismissAll();
              }
              else{
                this.errorService.toastErrors(response.errors);
              }
            });
        }, (error) => {
          this.errorService.toastErrors(error);
        });
  }
}
